import axios from 'axios';
import constants from './constants';
import store from '../store';
import { logout } from '../store/authSlice';
import { showToast } from '../store/toastSlice';

axios.defaults.baseURL = constants.baseURL;

axios.interceptors.request.use(
  function (config) {
    const token = store.getState().auth.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      store.dispatch(logout());
    } else {
      store.dispatch(showToast(error.response.data.message));
    }
    return Promise.reject(error);
  }
);

export default axios;
